import { render, staticRenderFns } from "./Gallery6.vue?vue&type=template&id=5ade54f7&scoped=true"
import script from "./Gallery6.vue?vue&type=script&lang=js"
export * from "./Gallery6.vue?vue&type=script&lang=js"
import style0 from "./Gallery6.vue?vue&type=style&index=0&id=5ade54f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade54f7",
  null
  
)

export default component.exports